// removed by extract-text-webpack-plugin
module.exports = {"block":"aGv_3EKUR5L0DkSK709IP","links":"zorDe6Q02ZoUtBljuyBtP","link":"Zxei4LyEtAK3Au89rGSqg","zebra":"_3Y1aLElyqEOrtt7cbI1TzU","yellow":"_2FhczXrNzrySJu7B0Yhlb4","darkgray":"_3h7RLfk6xoLsZUWWW5MQhr","bg":"_2vgHr0K6qqzRyFJvt-Io4_","heading":"_1CW4mbIy88Cq7MRhbDtU7O","active":"_3Ye0Ji9o_RtembTBPwpb-m","content":"_3539CL4zsSwnAkmYrYPWFE"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BusinessAreaListBlock/BusinessAreaListBlock.module.scss
// module id = 738
// module chunks = 0